import { publicUrlFor } from "../../../../globals/constants";
import { NavLink } from "react-router-dom";

function SectionWhyChooseUs1() {
    return (
        <>
            <div className="section-full p-t110 p-b80 sx-why-chooseus-outer sx-bg-light bg-cover" style={{ backgroundImage: `url(${publicUrlFor("images/background/team.png")})`,backgroundRepeat:'no-repeat' }}>
                <div className="container">
                    {/* TITLE START */}
                    <div className="section-head center">
                        <div className="sx-head-s-title" style={{color: '#fff'}}>ما در ویراپ چگونه به شما کمک میکنیم؟</div>
                        <div className="sx-head-l-title">
                            <h2 className="sx-title" dir="rtl">ویراپ تیمی از متخصصان جوان و خلاق است که با پشتوانه تحصیلات عالی و تجربه در حوزه فناوری اطلاعات، امکان طراحی و توسعه نرم‌افزارهای سفارشی، سامانه‌های پیشرفته، و راهکارهای هوش مصنوعی و تحلیل داده را فراهم کرده است. ما متعهد به ارائه خدماتی هستیم که سازمان‌ها را در مسیر رشد و تحول دیجیتال یاری می‌دهد.</h2>
                        </div>
                    </div>
                    {/* TITLE END */}
                    <div className="section-content" style={{direction:'rtl'}}>
                        <div className="sx-icon-bx-wrap">
                            <div className="row">
                                {/* Block one */}
                                <div className="col-lg-4 col-md-6 wow fadeInDown" data-wow-duration="1000ms">
                                    <div className="sx-icon-bx-1">
                                        <div className="sx-icon-box-wraper">
                                            <div className="sx-icon-bx-icon ">
                                                <span className="sx-text-primary"><i className="flaticon-data" /></span>
                                            </div>
                                            <div className="icon-content">
                                                <NavLink to="/services/detail" ><h4 className="sx-tilte" >سامانه‌های مبتنی بر AI</h4></NavLink>
                                                <p>طراحی و پیاده‌سازی اپلیکیشن‌ها و سامانه‌هایی که از الگوریتم‌های هوش مصنوعی برای بهبود فرآیندها، پیش‌بینی داده‌ها، و افزایش کارایی بهره می‌برند.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Block Two */}
                                <div className="col-lg-4 col-md-6 wow fadeInDown" data-wow-duration="1000ms">
                                    <div className="sx-icon-bx-1">
                                        <div className="sx-icon-box-wraper">
                                            <div className="sx-icon-bx-icon ">
                                                <span className="sx-text-primary"><i className="flaticon-programmer" /></span>
                                            </div>
                                            <div className="icon-content">
                                                <NavLink to="/services/detail"><h4 className="sx-tilte">راهکارهای هوش تجاری (BI)</h4></NavLink>
                                                <p>ارائه سیستم‌های هوش تجاری برای استخراج و تحلیل داده‌های سازمانی، تهیه گزارش‌های دقیق و بهینه‌سازی فرآیندهای تصمیم‌گیری.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Block Three */}
                                <div className="col-lg-4 col-md-6 wow fadeInDown" data-wow-duration="1000ms">
                                    <div className="sx-icon-bx-1">
                                        <div className="sx-icon-box-wraper">
                                            <div className="sx-icon-bx-icon ">
                                                <span className="sx-text-primary"><i className="flaticon-positive-review" /></span>
                                            </div>
                                            <div className="icon-content">
                                                <NavLink to="/services/detail"><h4 className="sx-tilte">تحلیل داده‌ها و ارائه بینش‌های عملیاتی</h4></NavLink>
                                                <p>جمع‌آوری، پردازش و تحلیل داده‌های سازمانی برای استخراج الگوها و بینش‌های ارزشمند که به تصمیم‌گیری استراتژیک کمک می‌کنند.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Block Four */}
                                <div className="col-lg-4 col-md-6 wow fadeInDown" data-wow-duration="1000ms">
                                    <div className="sx-icon-bx-1">
                                        <div className="sx-icon-box-wraper">
                                            <div className="sx-icon-bx-icon ">
                                                <span className="sx-text-primary"><i className="flaticon-profit" /></span>
                                            </div>
                                            <div className="icon-content">
                                                <NavLink to="/services/detail"><h4 className="sx-tilte">توسعه انواع نرم‌افزارهای سفارشی</h4></NavLink>
                                                <p>طراحی و توسعه نرم‌افزارهای سفارشی که متناسب با نیازهای خاص سازمان‌ها طراحی شده‌اند، از نرم‌افزارهای کوچک تا سیستم‌های گسترده.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Block Five */}
                                <div className="col-lg-4 col-md-6 wow fadeInDown" data-wow-duration="1000ms">
                                    <div className="sx-icon-bx-1">
                                        <div className="sx-icon-box-wraper">
                                            <div className="sx-icon-bx-icon ">
                                                <span className="sx-text-primary"><i className="flaticon-chart" /></span>
                                            </div>
                                            <div className="icon-content">
                                                <NavLink to="/services/detail"><h4 className="sx-tilte">توسعه و پشتیبانی سامانه‌های سازمانی و بانکی</h4></NavLink>
                                                <p>ارائه خدمات طراحی، توسعه و پشتیبانی سامانه‌های سازمانی و بانکی با تمرکز بر امنیت، سرعت و قابلیت اعتماد بالا.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Block SIx */}
                                <div className="col-lg-4 col-md-6 wow fadeInDown" data-wow-duration="1000ms">
                                    <div className="sx-icon-bx-1">
                                        <div className="sx-icon-box-wraper">
                                            <div className="sx-icon-bx-icon ">
                                                <span className="sx-text-primary"><i className="flaticon-parking" /></span>
                                            </div>
                                            <div className="icon-content">
                                                <NavLink to="/services/detail"><h4 className="sx-tilte">توسعه برنامه‌های غیرمتمرکز مبتنی بر EVM</h4></NavLink>
                                                <p>طراحی و توسعه برنامه‌های غیرمتمرکز (DApps) مبتنی بر ماشین مجازی اتریوم (EVM) برای کاربردهای مالی، قراردادهای هوشمند و سایر حوزه‌های نوآورانه</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionWhyChooseUs1;